import { API_BASE } from '../../shared/config/constants';

export const formatPrice = (value) => `${Number(value || 0).toLocaleString('en-US')} ₾`;
export const getProductPrice = (product) => {
  const price = Number(product?.price || 0);
  const salePrice = Number(product?.salePrice || 0);
  return salePrice > 0 && salePrice < price ? salePrice : price;
};

export const resolveImageUrl = (img) => {
  if (!img || typeof img !== 'string') return '';
  if (img.startsWith('data:image/svg+xml')) {
    const encoded = img.slice(img.indexOf(',') + 1);
    try {
      const svg = img.includes(';base64') ? window.atob(encoded) : decodeURIComponent(encoded);
      if (/>\s*No Image\s*</i.test(svg)) return '';
    } catch {
      return '';
    }
  }
  if (img.startsWith('http://') || img.startsWith('https://') || img.startsWith('data:image/')) {
    return img;
  }
  if (img.startsWith('/')) {
    return `${API_BASE}${img}`;
  }
  return img;
};

export const safeImage = (product) => {
  const images = Array.isArray(product?.images) ? product.images : (product?.image ? [product.image] : []);
  for (const img of images) {
    const resolved = resolveImageUrl(img);
    if (resolved) return resolved;
  }
  return '';
};

export const getProductImages = (product) => {
  const rawList = Array.isArray(product?.images) ? product.images : (product?.image ? [product.image] : []);
  const resolvedList = rawList.map(resolveImageUrl).filter(Boolean);
  if (resolvedList.length > 0) return resolvedList;
  return [];
};

export const categoryName = (category) => {
  const value = typeof category === 'object' && category
    ? category.name || category.slug
    : category;
  const normalized = String(value || '').trim().toLowerCase();
  const labels = {
    airconditioner: 'Air Care',
    washingmachine: 'Washing Machines',
  };
  if (labels[normalized]) return labels[normalized];
  return normalized.replace(/[-_]/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
};
